import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useRef } from "react";

const SilentAuth = () => {
  const { getAccessTokenSilently, isAuthenticated, loginWithRedirect, logout } = useAuth0();
  const idleTimerRef = useRef(null);

  const resetIdleTimer = () => {
    if (idleTimerRef.current) {
      clearTimeout(idleTimerRef.current);
    }

    idleTimerRef.current = setTimeout(() => {
      logout({ returnTo: window.location.origin });
    }, 15 * 60 * 1000); // 15 minutes
  };

  useEffect(() => {
    if (!isAuthenticated) return;

    // Activity events to listen to
    const activityEvents = ["mousemove", "keydown", "scroll", "touchstart"];

    activityEvents.forEach(event =>
      window.addEventListener(event, resetIdleTimer)
    );

    // Start the initial timer
    resetIdleTimer();

    return () => {
      // Cleanup
      activityEvents.forEach(event =>
        window.removeEventListener(event, resetIdleTimer)
      );
      clearTimeout(idleTimerRef.current);
    };
  }, [isAuthenticated, logout]);

  // Keep token fresh
  useEffect(() => {
    const refreshToken = async () => {
      if (!isAuthenticated) return;

      try {
        await getAccessTokenSilently();
      } catch (error) {
        if (error.error === "login_required") {
          loginWithRedirect(); // Redirect if session expired
        }
      }
    };

    const interval = setInterval(() => {
      refreshToken();
    }, 5 * 60 * 1000); // Refresh token every 5 minutes

    return () => clearInterval(interval);
  }, [getAccessTokenSilently, isAuthenticated, loginWithRedirect]);

  return null;
};

export default SilentAuth;
